import ValidateResponse from "./ValidateResponse";

export default interface DateValidateResponse extends ValidateResponse {
    from: string[];
    to: string[];
    fromAndTo: string[];
}

export const defaultValue = (): DateValidateResponse => {
    return {
        value: [],
        operator: [],
        from: [],
        to: [],
        fromAndTo: [],
        isValid: true,
        default: []
    };
}